import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Failure!", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Your order payment has failed", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("My Parties")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header),
      _createVNode(_component_ion_content, { class: "checkout-steps-page" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "pad-bot-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    sizeMd: "6",
                    class: "white-bg pad-top pad-bot border-radius-sm ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode("p", null, _toDisplayString(_ctx.getMessage()), 1),
                      _createVNode(_component_router_link, { to: "/account/my-parties" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, null, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}